/**
 * Legacy-Redirect: /account → /settings
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/account')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', replace: true })
  },
  component: () => null,
})
